import React from 'react';
//styles and icons 
import { Paper } from '@material-ui/core';
import { Col } from 'react-bootstrap';
import experienceIcon from '../../../images/work.svg';

// this component represent the profile work experience part in explore opportunities page 
export default function WorkExperience(props) {
    let workExperience = props.data;
    return (
        <React.Fragment>
            <Paper className="p-3 mt-4" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                <header className="row m-0 mb-3 align-items-center">
                    <Col className="text-left p-0 " xs={8}>
                        <h6 className="bold mb-0">
                            <span ><img src={experienceIcon} className="pr-3" alt="icon" /></span>
                                Work Experience</h6>
                    </Col>
                </header>
                {(workExperience) ?
                    workExperience.map(workExperience =>
                        <main key={workExperience.id} id={workExperience.id} className="row m-0">
                            <Col xs={9} className="p-0">
                                <h6 className="captialize bold">{workExperience.title + ' at ' + workExperience.at_name}</h6>
                                <div><p className="text-grey mb-0">
                                    {workExperience.start_time.substring(0, 7)} - {(workExperience.finish_time) ? workExperience.finish_time.substring(0, 7) : 'Present'}</p>
                                </div>
                            </Col>
                            <Col md={9} className="p-0">
                                <p>{(workExperience.bio) ? workExperience.bio : ''}</p>
                            </Col>
                            <Col xs={12} className="border-bottom mt-2 mb-2"></Col>
                        </main>)
                    : ''}
            </Paper>
        </React.Fragment>
    )
}

